/*
 * @Author: your name
 * @Date: 2020-09-18 10:19:01
 * @LastEditTime: 2021-02-19 16:43:29
 * @LastEditors: lwq
 * @Description: In User Settings Edit
 * @FilePath: \web_admin\src\utils\encrypt.js
 */

import { KEYUTIL, KJUR, hextob64 } from "jsrsasign"
export default ({ msg, key }) => {
  const pubkey = `-----BEGIN PUBLIC KEY-----${key}-----END PUBLIC KEY-----`
  const pub = KEYUTIL.getKey(pubkey)
  const enc = KJUR.crypto.Cipher.encrypt(msg, pub)
  // return utf16to8(hextob64(enc))
  return hextob64(enc)
}

function utf16to8(str) {
  var out, i, len, c

  out = ""
  len = str.length
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i)
    if (c >= 0x0001 && c <= 0x007f) {
      out += str.charAt(i)
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f))
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
    } else {
      out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f))
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f))
    }
  }
  return out
}
// MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDBt8jiwvO7FtHq6C56r+bPq/xpusHei6pemRDs
//   ↵rNnIjQHCSM3LRT73pYQDPJ+/DdV9i9InjViEZcme6f60k1pIPKppLUISIRLUYes7zWSqsHHoU19W
//   ↵EURlhTnO+w1XOGYOwmv8bE6G3N36kCxcD3Mi6g+6PjhDM3VKn060mkCp9wIDAQAc
